import * as React from "react";
import { connect } from "react-redux";

import { Button, Divider, Container } from "semantic-ui-react";

import { ApplicationState } from "../../applicationState";

import { CreateLinkedImmunisationCaseModal } from "./CreateLinkedImmunisationCaseModal";

import { Link } from "redux-little-router";

const CreateLinkedImmunisationCaseButtonUnconnected: React.FunctionComponent<{ path: string }> = (props) => {
    return (
        <>
            <Divider />
            <Container textAlign="right">
                <Link href={`${props.path}/createImmunisationCase`}>
                    <Button content="Open Immunisation Case"></Button>
                </Link>
            </Container>
            <CreateLinkedImmunisationCaseModal />
        </>
    );
};

const mapStateToProps = (state: ApplicationState) => ({
    path: state.router.pathname
});

export const CreateLinkedImmunisationCaseButton = connect(mapStateToProps)(CreateLinkedImmunisationCaseButtonUnconnected);
